//include 4 
jQuery(function(){
    var privateFunctions = {
        reloadIfEmpty(elements){
            elements.each(function(){
                var element = $(this);            
                var cid = element.data("cid");
                var pid = element.data("pid");
                var checkFor = element.data("check-for");
                if(!cid || !pid){
                    return;
                }
                var isEmpty = false;
                if(!!checkFor){
                    if(element.find(checkFor).length == 0){
                        isEmpty = true;
                    }
                }
                else{
                    if(!$.trim(element.html())){
                        isEmpty = true;
                    }
                }
                if(isEmpty){
                    window.pixelpoint.ppComponents.module.reload(element);
                }
            });
        }
    };

    window.pixelpoint.ppComponents.module.reloadIfEmpty = privateFunctions.reloadIfEmpty;
    window.pixelpoint.ppComponents.module.reloadIfEmpty($("[data-reload-if-empty]"));
});